module.exports = __webpack_public_path__ + "img/icon9.9da2d7d.png";